import { AccoListerAcco } from '@/scopes/common/domain/acco-lister/types'
import { Carousel } from '@sunwebgroup/uds-ui/carousel'
import { AccoCard } from '../AccoCard'
import styles from './AccoList.module.css'

export interface AccoListProps {
  accos: AccoListerAcco[] | undefined
  nextButtonLabel: string
  prevButtonLabel: string
  hasControls?: boolean
  onClickEventCallback?: (acco: AccoListerAcco, isLoggedIn: boolean, accoBrand: string) => void
}

export function AccoList({
  accos,
  nextButtonLabel,
  prevButtonLabel,
  hasControls = true,
  onClickEventCallback,
}: AccoListProps) {
  if (!accos) {
    return null
  }

  return (
    <Carousel
      hasControls={hasControls}
      nextButtonAriaLabel={nextButtonLabel}
      prevButtonAriaLabel={prevButtonLabel}
      className={styles.wrapper}
    >
      {accos?.map(acco => (
        <AccoCard key={acco.id} acco={acco} onClickCallback={onClickEventCallback} />
      ))}
    </Carousel>
  )
}
